import { MapContext } from 'contexts/MapContext';
import * as Styled from './styles';
import { IoIosColorPalette } from 'react-icons/io';
import React, { useContext } from 'react';

export function ColorMenu() {
  const { colorDraw, handleChangeColor } = useContext(MapContext);

  return (
    <Styled.ColorBox>
      <Styled.ColorHeader>
        <IoIosColorPalette />
        <span>Cor do desenho</span>
      </Styled.ColorHeader>

      <Styled.ColorGroup>
        <label>Selecione a cor</label>
        <Styled.ColorInput
          type="color"
          value={colorDraw}
          onChange={(e) => handleChangeColor(e.target.value)}
          aria-label="Selecione a cor do desenho"
        />
      </Styled.ColorGroup>
    </Styled.ColorBox>
  );
}
